import React from 'react';
import { BankHolidayUplift } from 'AppClient/api/Bookings/BokkingsTypes';
import { toDate } from 'utils/converters';

interface Props {
	data: BankHolidayUplift | null;
}
export const BankHolidayTCText: React.FC<Props> = props => {
	const { data } = props;
	const getTitle = () => <h5>Bank Holiday Surcharges (included in quotation)</h5>;
	const getContent = () => {
		if (!data) {
			return emptyContent();
		}

		return fullContent(data);
	};

	const emptyContent = () => <p>There is no bank holiday surcharge.</p>;

	const fullContent = ({ holidayName, date, upliftPercentages }: BankHolidayUplift) => {
		return (
			<div>
				<div>
					Holiday: <strong>{holidayName}</strong>
				</div>
				<div>
					Date: <strong>{toDate(date)}</strong>
				</div>
				<div>
					Uplift: <strong>{upliftPercentages}%</strong>
				</div>
			</div>
		);
	};

	return (
		<>
			{getTitle()}
			{getContent()}
		</>
	);
};
